// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"infoWrapper--REGpt"};